"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ClockIcon = (props) => {
    return (react_1.default.createElement("svg", { className: props.size, viewBox: "0 0 24 24", fill: "none" },
        react_1.default.createElement("path", { className: props.color, d: "M12 2C6.48578 2 2 6.48578 2 12C2 17.5142 6.48578 22 12 22C17.5142 22 22 17.5142 22 12C22 6.48578 17.5142 2 12 2ZM16.7559 17.1724C16.5934 17.3349 16.38 17.4167 16.1667 17.4167C15.9534 17.4167 15.7399 17.3349 15.5776 17.1724L11.4109 13.0059C11.2542 12.8501 11.1667 12.6383 11.1667 12.4167V7C11.1667 6.53918 11.5399 6.16672 12 6.16672C12.4601 6.16672 12.8333 6.53918 12.8333 7V12.0717L16.7559 15.9941C17.0816 16.3201 17.0816 16.8466 16.7559 17.1724Z" })));
};
exports.default = ClockIcon;
